import Controller from '@ember/controller';

export default class StateAndLocalController extends Controller {
  queryParams = ['preserveScrollPosition'];
  preserveScrollPosition = true;
}
